import { ApiAction, initialPaginatedApiState, PaginatedApiState } from '../../utils/requestAction'
import requestReducer from '../requestReducer'
import Complaint from '../../models/Complaint'

export interface ComplaintListState extends PaginatedApiState {
complaints?: Complaint[] 
}

const ComplaintList = (state: ComplaintListState = initialPaginatedApiState, action: ApiAction) => {
  switch (action.type) {
    default:
      return requestReducer<ComplaintListState>('COMPLAINT_LIST')(state, action)
  }
}

export default ComplaintList
